import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import _ from "lodash";

import { PersonalChart } from "components/PersonalChart";
import { GlobalState } from "contexts/GlobalState";
import { Notes } from "components/Notes";
import { Arrows } from "components/programCardComponents/Arrows";
import { RemoveFavorite } from "components/RemoveFavorite";
import { SemestersButtons } from "components/programCardComponents/SemestersButtons";
import { SearchResultsBody } from "components/programCardComponents/SearchResultsBody";
import { OpenUntilAndSignUp } from "components/programCardComponents/OpenUntilAndSignUp";
import { Circle } from "components/programCardComponents/Circle";
import { UniversityComments } from "components/programCardComponents/UniversityComments";
import "./style.scss";

export const FavoriteProgramCard = ({
    favoriteData,
    getAllFavorites,
    item,
    labels,
    searchResultsLabels,
    notes,
    trackId
}) => {
    const [globalUser, setGlobalUser] = GlobalState("user");
    const [acceptanceStatus, setAcceptanceStatus] = useState("");

    const findAcceptanceStatus = () => {
        const acceptanceGrade = item.field_semester[0]?.field_this_year_receipt_threshol;
        const rejectionGrade = item.field_semester[0]?.field_this_year_rejection_thresh;
        const gradeOfUser = globalUser.user?.adapter;
        if (acceptanceGrade && rejectionGrade && gradeOfUser) {
            if (gradeOfUser >= acceptanceGrade) {
                setAcceptanceStatus(labels.acceptance);
            } else if (gradeOfUser < rejectionGrade) {
                setAcceptanceStatus(labels.rejection);
            } else {
                setAcceptanceStatus(labels.still_waiting);
            }
        }
    };

    useEffect(() => {
        if (globalUser?.user?.adapter) {
            findAcceptanceStatus();
        }
    }, [globalUser]);

    const [semester, setSemester] = useState({
        // number: 0,
        // title: item?.field_semester?.[0]?.title,
        // field_this_year_receipt_threshol: item?.field_semester?.[0]?.field_this_year_receipt_threshol,
        // field_this_year_rejection_thresh: item?.field_semester?.[0]?.field_this_year_rejection_thresh,
        // field_end_registration: item?.field_semester?.[0]?.field_end_registration,
    });

    useEffect(() => {
        item?.field_semester && item?.field_semester.forEach((semesterObg, i) => {
            if (semesterObg) {
                setSemester((prevState) => ({ ...prevState, number: i }));
                setSemester((prevState) => ({ ...prevState, title: semesterObg?.title }));
                setSemester((prevState) => ({ ...prevState, field_this_year_receipt_threshol: semesterObg?.field_this_year_receipt_threshol }));
                setSemester((prevState) => ({ ...prevState, field_this_year_rejection_thresh: semesterObg?.field_this_year_rejection_thresh }));
                setSemester((prevState) => ({ ...prevState, field_end_registration: semesterObg?.field_end_registration }));

            }
        })
    }, [item]);

    return (
        <div className="favorite-program-card">
            <Row className="arrows-row">
                <Arrows
                    favoriteData={favoriteData}
                    item={item}
                    getAllFavorites={getAllFavorites}
                    md={12}
                    labels={labels}
                ></Arrows>
            </Row>
            <Row className="wrapper-for-border">
                <Col xs={12} md={6} className="details">
                    <Row>
                        <Circle />
                        <Col sm={9} md={10} className="p-0">
                            <Row>
                                <SearchResultsBody
                                    md={10}
                                    item={item}
                                    labels={searchResultsLabels}
                                />
                                <div>
                                    <Col md={12} className="semesters-row">
                                        <SemestersButtons
                                            item={item}
                                            semester={semester}
                                            setSemester={setSemester}
                                            labels={searchResultsLabels}
                                        />
                                    </Col>
                                    <Notes
                                        item={item}
                                        parentWidget="parent-is-search-result"
                                        labels={labels}
                                        defaultNotes={notes ?? ""}
                                    />
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Col sm={12} md={6} className="details details-2">
                    <Row className="add-to-favorite-wrapper">
                        <RemoveFavorite
                            item={item}
                            getAllFavorites={getAllFavorites}
                            labels={searchResultsLabels}
                        />
                    </Row>
                    <Row>
                        <PersonalChart
                            labels={searchResultsLabels}
                            rejectionScore={semester.field_this_year_rejection_thresh}
                            acceptanceScore={semester.field_this_year_receipt_threshol}
                            width={Utils.isMobile() ? "48.1em" : "31.75em"}
                            height={Utils.isMobile() ? "25em" : "19.5em"}
                            info={true}
                            border={"show"}
                            stats_sentence={true}
                        />
                    </Row>
                    <Row className="acceptance-status">
                        <label>{labels.acceptance_status}<strong> {acceptanceStatus}</strong></label>
                    </Row>
                    <UniversityComments item={item} />
                </Col>
                {Utils.isMobile() && (
                    <Col sm={12} className="notes-col p-0">
                        <Notes
                            item={item}
                            labels={labels}
                            defaultNotes={notes ?? ""}
                        />
                    </Col>
                )}
                <Col sm={12} md={12} className="open-until-and-signup-col p-0">
                    <OpenUntilAndSignUp
                        labels={searchResultsLabels}
                        semester={semester}
                        item={item}
                        trackId={trackId}
                    />
                </Col>
            </Row>
        </div>
    )
}
